import { useNavigate } from 'react-router-dom';
import loginWithGithub from '../loginWithGithub';
import { useAuth } from '../AuthContext';
import AnimatedLogo from './AnimatedLogo';
import { useEffect, useRef } from 'react';
import glitchEffect from '../utils/glitchEffect';

const Hero = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const buildRef = useRef(null); // 👈 add ref

  useEffect(() => {
    glitchEffect();

    // ✅ Fix the paint issue on iOS (forces repaint)
    window.addEventListener('load', () => {
      requestAnimationFrame(() => {
        if (buildRef.current) {
          buildRef.current.style.transform = 'translateZ(0)';
          setTimeout(() => {
            buildRef.current.style.transform = '';
          }, 100);
        }
      });
    });
  }, []);

  const handleClick = async () => {
    if (!user) {
      try {
        await loginWithGithub();
      } catch (err) {
        console.error("GitHub login failed", err);
        return;
      }
    }
    navigate('/builder');
  };

  return (
    <section className="hero">
      <div className="container text-center">
        <div className="mb-3">
          <AnimatedLogo />
        </div>
        <h1 className="fw-bold responsive-heading">
  <span className="color-build" ref={buildRef}>Build</span>
  <span className="rest-heading"> Your <span className="color-step">Dev</span> <span id="glitch-heading">Portfolio</span></span>
</h1>


        <p className="lead">Create and share a beautiful, professional developer portfolio in minutes.</p>
        <button className="btn btn-primary btn-lg get-started-btn" onClick={handleClick}>
          Get Started with GitHub
        </button>
      </div>
    </section>
  );
};

export default Hero;
